module.exports = __webpack_public_path__ + "media/customizations/sterlingranch/back-7b2c9d5c2e006f1f0b2977645cbf1c27.jpg";